:host{display:flex;justify-content:space-between}:host .button-wrapper{display:flex}:host .message-container{align-self:center}
/*# sourceMappingURL=detailed-message.component.css.map */
